/* eslint-disable */
import Swiper from "swiper";
import "swiper/css";
import { Navigation, Pagination, EffectFade, Parallax } from "swiper/modules";
import "swiper/css/pagination";
import gsap from "gsap";

/* ================================================= */

const swiperCustomCount = (currentSwiper, paginationCurrent) => {

  if (currentSwiper) {
    currentSwiper.on("slideChange", () => {
      const inx = currentSwiper.realIndex + 1;

      gsap.to(paginationCurrent, 0.3, {
        force3D: true,
        y: -5,
        opacity: 0,
        onComplete: function() {
          gsap.to(paginationCurrent, 0.1, {
            force3D: true,
            y: 5,
          });

          if (inx >= 10) {
            paginationCurrent.innerHTML = `${inx}`;
          } else {
            paginationCurrent.innerHTML = `0${inx}`;
          }
        },
      });
      gsap.to(paginationCurrent, 0.3, {
        force3D: true,
        y: 0,
        opacity: 1,
        delay: 0.4,
      });
    });
  }
};

/* ================================================= */

function initHeroSwiper() {
  const el = document.querySelector(".hero-section__swiper");
  if (!el) return null;

  if (el.swiper) {
    el.swiper.destroy(true, true);
  }

  if (!el.querySelector(".swiper-slide")) return null;

  return new Swiper(el, {
    modules: [Navigation, Pagination, EffectFade],
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 650,
    loop: true,
    watchOverflow: true,
    autoHeight: true,

    navigation: {
      nextEl: ".hero-section__next",
    },

    pagination: {
      el: ".hero-section__pagination",
    },
  });
}

window.initHeroSwiper = initHeroSwiper;
initHeroSwiper();

/* ================================================= */

const popupPortfolioEl = document.querySelector(".popup-portfolio__swiper");
if (popupPortfolioEl) {
  // eslint-disable-next-line no-new
  new Swiper(popupPortfolioEl, {
    modules: [Navigation, Pagination, Parallax],
    loop: false,
    parallax: true,
    speed: 1000,
    navigation: {
      nextEl: ".popup-portfolio__button-next",
      prevEl: ".popup-portfolio__button-prev",
    },
  });
}

/* ================================================= */

function initAdvantageSwiper() {
  const advantageSection = document.querySelector(".advantage-section");
  if (!advantageSection) return null;

  const el = advantageSection.querySelector(".advantage-section__swiper");
  if (!el) return null;

  if (el.swiper) {
    el.swiper.destroy(true, true);
  }

  if (!el.querySelector(".swiper-slide")) return null;

  const currentCount = advantageSection.querySelector(".custom-count__current");
  if (currentCount) currentCount.textContent = "01";

  // Desktop uses CSS grid; swiper only on mobile.
  if (window.innerWidth > 1023) {
    el.dataset.mobile = "false";
    return null;
  }

  el.dataset.mobile = "true";
  const advantageSectionSwiper = new Swiper(el, {
    modules: [Navigation, Pagination],
    spaceBetween: 24,
    slidesPerView: "auto",

    navigation: {
      nextEl: ".advantage-section__button-next",
      prevEl: ".advantage-section__button-prev",
    },

    pagination: {
      el: ".advantage-section__pagination-count .custom-count__total",
      type: "custom",
      renderCustom: function(swiper, current, total) {
        if (total >= 10) {
          return `${total}`;
        }
        return `0${total}`;
      },
    },
  });

  swiperCustomCount(advantageSectionSwiper, currentCount);
  return advantageSectionSwiper;
}

window.initAdvantageSwiper = initAdvantageSwiper;
initAdvantageSwiper();

/* ================================================= */

function initHistorySwiper() {
  const historySection = document.querySelector(".history-section");
  if (!historySection) return null;
  const el = historySection.querySelector(".history-section__swiper");
  if (!el) return null;
  if (el.swiper) el.swiper.destroy(true, true);

  const currentCount = historySection.querySelector(".custom-count__current");
  const historySectionSwiper = new Swiper(el, {
    modules: [Navigation, Pagination],
    spaceBetween: 24,
    slidesPerView: 1,
    speed: 1000,
    navigation: {
      nextEl: historySection.querySelector(".history-section__button-next"),
      prevEl: historySection.querySelector(".history-section__button-prev"),
    },
    pagination: {
      el: historySection.querySelector(".history-section__pagination-count .custom-count__total"),
      type: "custom",
      renderCustom: function(swiper, current, total) {
        if (total >= 10) return `${total}`;
        return `0${total}`;
      },
    },
  });
  swiperCustomCount(historySectionSwiper, currentCount);
  return historySectionSwiper;
}

initHistorySwiper();

/* ================================================= */

const bigSliderEl = document.querySelector(".big-slider__swiper");
let bigSliderSwiper = null;
if (bigSliderEl) {
  bigSliderSwiper = new Swiper(bigSliderEl, {
    modules: [Navigation, Pagination, Parallax],
    loop: false,
    parallax: true,
    speed: 1000,
    pagination: {
      el: ".swiper-pagination",
    },
    navigation: {
      nextEl: ".big-slider__button-next",
      prevEl: ".big-slider__button-prev",
    },
    breakpoints: {
      992: {
        pagination: {
          el: ".big-slider__pagination-count .big-slider__pagination-total",
          type: "custom",
          renderCustom: function(swiper, current, total) {
            return `0${total}`;
          },
        },
      },
    },
  });

  const bigSliderPaginationCurrent = document.querySelector(".big-slider__pagination-current");
  if (bigSliderPaginationCurrent) {
    bigSliderSwiper.on("slideChange", () => {
      const inx = bigSliderSwiper.realIndex + 1;
      gsap.to(bigSliderPaginationCurrent, 0.3, {
        force3D: true,
        y: -5,
        opacity: 0,
        onComplete: function() {
          gsap.to(bigSliderPaginationCurrent, 0.1, {
            force3D: true,
            y: 5,
          });
          bigSliderPaginationCurrent.innerHTML = `0${inx}`;
        },
      });
      gsap.to(bigSliderPaginationCurrent, 0.3, {
        force3D: true,
        y: 0,
        opacity: 1,
        delay: 0.4,
      });
    });
  }
}

/* ================================================= */

function initSlideRowSwipers(root = document) {
  const swiperJs = root.querySelectorAll(".swiper-js");
  swiperJs.forEach((swiperSection) => {
    const currentSwiper = swiperSection.querySelector(".swiper");
    const nextEl = swiperSection.querySelector(".slide-row__next");
    const prevEl = swiperSection.querySelector(".slide-row__prev");
    const total = swiperSection.querySelector(".custom-count__total");
    const currentCount = swiperSection.querySelector(".custom-count__current");

    if (currentSwiper && total && currentCount) {
      if (currentSwiper.swiper) currentSwiper.swiper.destroy(true, true);
      const instance = new Swiper(currentSwiper, {
        modules: [Navigation, Pagination],
        spaceBetween: 24,
        slidesPerView: "auto",
        navigation: {
          nextEl,
          prevEl,
        },
        pagination: {
          el: total,
          type: "custom",
          renderCustom: function(swiper, current, total) {
            if (total >= 10) return `${total}`;
            return `0${total}`;
          },
        },
      });
      swiperCustomCount(instance, currentCount);
    }
  });
}

initSlideRowSwipers();

window.reinitAboutSwipers = function reinitAboutSwipers() {
  initHistorySwiper();
  const about = document.querySelector(".about-page");
  if (about) initSlideRowSwipers(about);
};
